import { Inject, Injectable, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { TokywokyMessage } from '../../models/tokywoky-message';
import { MISC_CONST } from '../../../utils/const/misc';
import { UserStoreService } from '../state-management/user-store.service';
import { distinctHydraMember, filterUndefined, subRProperty } from '@adeo/ngx-kozikaza-api';
import { BehaviorSubject, from, of, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

declare let toky_auth_apiKey;
declare let toky_auth_message;
declare let toky_auth_hmac;
declare let toky_auth_timestamp;
declare let toky_id;

@Injectable({
    providedIn: 'root'
})
export class TokywokyService {

    private scriptExist$: BehaviorSubject<any> = new BehaviorSubject(false);
    private _initScript$: Subject<void> = new Subject();

    constructor(
        private readonly userStoreService: UserStoreService,
        @Inject(PLATFORM_ID) private platformId: object,
        @Inject(LOCALE_ID) public currentLanguage,
    ) {
        this._initScript$.asObservable().pipe(
            switchMap(() => this.userStoreService.userStore.pipe(
                filterUndefined(),
                distinctHydraMember(),
                switchMap((currentUser) => {
                    if (!!currentUser) {
                        const message: TokywokyMessage = {
                            id: currentUser['@id'],
                            nickname: currentUser.username,
                            email: currentUser.email,
                            profilePicture: subRProperty(currentUser, ['avatar', 'thumbs', 'small'], 'it is empty')
                        };
                        const time = (Math.floor(Date.now() / 1000)).toString();

                        toky_auth_apiKey = MISC_CONST.TOKYWOKY_PUBLIC;
                        toky_auth_message = btoa(JSON.stringify(message));
                        return from(import('crypto-js')).pipe(
                            map((crypto) => {
                                const hmac = crypto.HmacSHA1(toky_auth_message + ' ' + time, MISC_CONST.TOKYWOKY_PRIVATE);
                                toky_auth_hmac = hmac.toString(crypto.enc.Hex);
                                toky_auth_timestamp = time;
                                return true;
                            })
                        );
                    } else {
                        return of(true);
                    }
                }),
                map(() => {
                    toky_id = '490';
                    this.scriptExist$.next(document.getElementById('tokywoky_script'));
                    if (!this.scriptExist$.getValue()) {
                        const script = document.createElement('script');
                        script.setAttribute('type', 'text/javascript');
                        script.setAttribute('defer', 'true');
                        script.setAttribute('id', 'tokywoky_script');
                        script.setAttribute('src', '//az601263.vo.msecnd.net/webview/' + toky_id + '/embed.js');
                        document.getElementsByTagName('body')[0].appendChild(script);
                        this.scriptExist$.next(true);
                        return true;
                    }
                    return false;
                })
            ))
        ).subscribe();
    }

    initTokyWoky(): boolean {
        if (isPlatformBrowser(this.platformId) && !this.scriptExist$.getValue() && this.currentLanguage === 'fr') {
            this._initScript$.next();
            return true;
        } else {
            return false;
        }
    }
}
